<ng-container>
  <h1 class="formSection__header">Load Information</h1>
  <div class="formGrid__esvr formGrid__esvr--3">
    <div class="loadInfo">
      <h2 class="input__title">ESVR</h2>
      <p>{{ loadInfo?.bol }}</p>
    </div>
    <div class="loadInfo">
      <h2 class="input__title">Batch Name</h2>
      <p>{{ loadInfo?.batchId }}</p>
    </div>
    <div class="loadInfo">
      <h2 class="input__title">Status</h2>
      <p>{{ loadInfo?.status }}</p>
    </div>
  </div>
  <div class="formGrid__esvr formGrid__esvr--3">
    <div class="loadInfo">
      <h2 class="input__title">Source Site</h2>
      <p>{{ loadInfo?.sourceSiteAddress }}</p>
    </div>
    <div class="loadInfo">
      <h2 class="input__title">Target Receiving Site</h2>
      <p>{{ loadInfo?.fillSiteAddress }}</p>
    </div>
  </div>
</ng-container>